<mtg-statistic-table
  *ngIf="forwards.length > 0"
  title="Нападающие"
  [statisticHeader]="getStatisticHeader()"
  [statistic]="forwards"
  [pageSize]="pageSize"
  [sport]="sport"
  [teamLogoVisible]="teamLogoVisible"
  [identity]="identity"
  [sort]="sortByForward || 'totalGoals'"
  [checkNewbie]="checkNewbie"
  order="desc"
></mtg-statistic-table>
<mtg-statistic-table
  *ngIf="defenders.length > 0"
  title="Защитники"
  [statistic]="defenders"
  [statisticHeader]="getStatisticHeader()"
  [pageSize]="pageSize"
  [sport]="sport"
  [teamLogoVisible]="teamLogoVisible"
  [identity]="identity"
  [sort]="sortByDefender || 'totalGoals'"
  [checkNewbie]="checkNewbie"
  order="desc"
></mtg-statistic-table>
<mtg-statistic-table
  *ngIf="goaltenders.length > 0"
  title="Вратари"
  [statistic]="goaltenders"
  [statisticHeader]="getStatisticHeader(true)"
  [goalie]="true"
  [pageSize]="pageSize"
  [sport]="sport"
  [teamLogoVisible]="teamLogoVisible"
  [identity]="identity"
  [sort]="sortByGoalkeeper || 'totalSavesPercent'"
  [checkNewbie]="checkNewbie"
  order="desc"
></mtg-statistic-table>
